import { appConfig } from "../../config/appConfig";

const canUseLocalStorage = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const hasTemporaryLaunchAccess = () => {
  if (!appConfig.temporaryLaunchGate.enabled) {
    return true;
  }

  if (!canUseLocalStorage()) {
    return false;
  }

  return (
    window.localStorage.getItem(appConfig.temporaryLaunchGate.storageKey) === "true"
  );
};

export const grantTemporaryLaunchAccess = () => {
  if (!canUseLocalStorage()) {
    return;
  }

  window.localStorage.setItem(appConfig.temporaryLaunchGate.storageKey, "true");
};
